import * as actionTypes from "../actionTypes";

const initialState = {
  setTerms: {
    loading: false,
    error: null,
    success: false,
  },
  generateIdeas: {
    loading: false,
    error: null,
    success: false,
    data: [],
    streaming: false,
  },
  getTerms: {
    loading: false,
    error: null,
    success: false,
    data: [],
  },
  downloadAction: {
    loading: false,
    error: null,
    success: false,
  },
  reorderActionTerm: {
    loading: false,
    error: null,
    success: false,
    data: null,
  },
  startActionPlan: {
    loading: false,
    error: null,
    success: false,
  },
};

const actionPlanReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_TERMS:
      return {
        ...state,
        getTerms: {
          loading: true,
          error: null,
          success: false,
          data: [],
        },
      };
    case actionTypes.GET_TERMS_SUCCESS:
      return {
        ...state,
        getTerms: {
          loading: false,
          error: null,
          success: true,
          data: payload,
        },
      };
    case actionTypes.GET_TERMS_ERROR:
      return {
        ...state,
        getTerms: {
          loading: false,
          error: "Failed to fetch action steps",
          success: false,
          data: [],
        },
      };
    case actionTypes.SET_GENERATE_IDEAS_SUCCESS:
      return {
        ...state,
        generateIdeas: {
          loading: false,
          error: null,
          success: true,
          data: payload,
          streaming: false,
        },
      };
    case actionTypes.SET_GENERATE_IDEAS_ERROR:
      return {
        ...state,
        generateIdeas: {
          loading: false,
          error: "Failed to generate ideas",
          success: false,
          data: [],
          streaming: false,
        },
      };
    case actionTypes.SET_GENERATE_IDEAS:
      return {
        ...state,
        generateIdeas: {
          loading: true,
          error: null,
          success: false,
          data: [],
          streaming: false,
        },
      };
    case actionTypes.SET_GENERATE_IDEAS_STREAM_START:
      return {
        ...state,
        generateIdeas: {
          ...state.generateIdeas,
          loading: true,
          error: null,
          success: false,
          data: [],
          streaming: true,
        },
      };
    case actionTypes.SET_GENERATE_IDEAS_STREAM_DELTA:
      return {
        ...state,
        generateIdeas: {
          ...state.generateIdeas,
          loading: true,
          error: null,
          success: false,
          data: [...(state.generateIdeas.data || []), payload],
          streaming: true,
        },
      };
    case actionTypes.SET_GENERATE_IDEAS_STREAM_DONE:
      return {
        ...state,
        generateIdeas: {
          ...state.generateIdeas,
          loading: false,
          error: null,
          success: true,
          streaming: false,
        },
      };
    case actionTypes.SET_GENERATE_IDEAS_STREAM_ERROR:
      return {
        ...state,
        generateIdeas: {
          loading: false,
          error: payload || "Failed to generate ideas",
          success: false,
          data: [],
          streaming: false,
        },
      };
    case actionTypes.SET_TERMS:
      return {
        ...state,
        setTerms: {
          loading: true,
          error: null,
          success: false,
        },
      };
    case actionTypes.SET_TERMS_SUCCESS:
      return {
        ...state,
        setTerms: {
          loading: false,
          error: null,
          success: true,
          data: payload,
        },
      };
    case actionTypes.SET_TERMS_ERROR:
      return {
        ...state,
        setTerms: {
          loading: false,
          error: payload,
          success: false,
        },
      };
    case actionTypes.DOWNLOAD_ACTION:
      return {
        ...state,
        downloadAction: {
          loading: true,
          error: null,
          success: false,
        },
      };
    case actionTypes.DOWNLOAD_ACTION_SUCCESS:
      return {
        ...state,
        downloadAction: {
          loading: false,
          error: null,
          success: true,
        },
      };
    case actionTypes.DOWNLOAD_ACTION_ERROR:
      return {
        ...state,
        downloadAction: {
          loading: false,
          error: payload || "Failed to download action plan",
          success: false,
        },
      };
    case actionTypes.REORDER_ACTION_TERM:
      return {
        ...state,
        reorderActionTerm: {
          loading: true,
          error: null,
          success: false,
          data: null,
        },
      };
    case actionTypes.REORDER_ACTION_TERM_SUCCESS:
      return {
        ...state,
        reorderActionTerm: {
          loading: false,
          error: null,
          success: true,
          data: payload,
        },
      };
    case actionTypes.REORDER_ACTION_TERM_ERROR:
      return {
        ...state,
        reorderActionTerm: {
          loading: false,
          error: payload || "Failed to reorder action steps",
          success: false,
          data: null,
        },
      };
    case actionTypes.START_ACTION_PLAN:
      return {
        ...state,
        startActionPlan: {
          loading: true,
          error: null,
          success: false,
        },
      };
    case actionTypes.START_ACTION_PLAN_SUCCESS:
      return {
        ...state,
        startActionPlan: {
          loading: false,
          error: null,
          success: true,
        },
      };
    case actionTypes.START_ACTION_PLAN_ERROR:
      return {
        ...state,
        startActionPlan: {
          loading: false,
          error: payload || "Failed to start action plan",
          success: false,
        },
      };
    default:
      return state;
  }
};
export default actionPlanReducer;
